/* eslint-disable import/no-named-as-default */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faCopy,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Backdrop,
  Modal,
  Title,
  TitleText,
  CloseButton,
  Body,
  Text,
  CopyButton,
  Copied,
  ArrowDown,
} from "./styles/referral-modal-styles";

let timer = null;

export class ReferralModal extends Component {
  state = {
    copied: false,
  };

  componentWillUnmount() {
    clearTimeout(timer);
  }

  handleCopiedState = () => {
    timer = setTimeout(() => this.setState({ copied: false }), 1500);
  };

  copyTextToClipboard = (text) => {
    const element = document.createElement("textarea");
    element.value = text;
    document.body.appendChild(element);
    element.select();
    document.execCommand("copy");
    document.body.removeChild(element);
    this.setState({ copied: true });

    this.handleCopiedState();
  };

  render() {
    const { toggleModal, firstName, userId } = this.props;
    const { copied } = this.state;

    const utmSource = "utm_source=hiring_hub";
    const utmCampaign = "utm_campaign=employer_referral_scheme";
    const referrerName = `referrer_name=${firstName}`;
    const referrerId = `referrer_id=${userId}`;
    const link = `https://www.hiring-hub.com/referral-incentive?${utmSource}&${utmCampaign}&${referrerName}&${referrerId}`;
    const textToCopy = `Hi,

I'm using Hiring Hub - a recruitment agency marketplace - to find quality candidates faster, I think you'd like it too.

If you want to try it and use the link below, we'll both get a £50 M&S voucher.

${link}

Thanks`;

    return (
      <Backdrop className="animated fadeIn">
        <Modal className="animated fadeInDown" data-test-id="referral-modal">
          <Title data-test-id="referral-modal-title">
            <TitleText>Refer a Friend!</TitleText>
            <CloseButton onClick={() => toggleModal()}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </Title>
          <Body data-test-id="referral-modal-text">
            <Text>
              Know someone you think would benefit from using Hiring Hub?
              <br />
              <br />
              Refer them to us and you’ll both get a £50 M&S voucher when they
              post their first job on Hiring Hub!
              <br />
              <br />
              You can paste this link into email, WhatsApp or an instant
              messaging app.
            </Text>
            <CopyButton
              onClick={() => this.copyTextToClipboard(textToCopy)}
              data-test-id="referral-modal-copy-button"
            >
              {copied && (
                <Copied
                  data-test-id="copied-tooltip"
                  className="animated fadeInUp"
                >
                  Auto copied template <FontAwesomeIcon icon={faCheckCircle} />
                  <ArrowDown />
                </Copied>
              )}
              Share your invite link
              <FontAwesomeIcon icon={faCopy} />
            </CopyButton>
          </Body>
        </Modal>
      </Backdrop>
    );
  }
}

ReferralModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  firstName: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
};

export default ReferralModal;
